// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2DX5i","noInteraction":"EventWrapper_noInteraction__1WD5F","pointerPassthrough":"EventWrapper_pointerPassthrough__1pRFx"};